import { PropsWithChildren, useMemo } from 'react';

import { XYChartAnnotationsShownIndicatorsContext } from '../context/XYChartAnnotationsShownIndicators.context.js';
import { useXYChartAnnotationsIndicators } from '../hooks/useXYChartAnnotationsIndicators.js';
import { useAnnotationsState } from '../store/selectors.js';

export const XYChartAnnotationsShownIndicatorsProvider = ({
  children,
}: PropsWithChildren) => {
  const { alwaysVisible, selectable } = useXYChartAnnotationsIndicators();
  const { data } = useAnnotationsState();

  const shownIndicators = useMemo(() => {
    const hoveredIndicators =
      data?.flatMap(({ key }) => {
        const indicator = selectable.get(key);
        return indicator ? [indicator] : [];
      }) ?? [];

    return [...hoveredIndicators, ...alwaysVisible];
  }, [data, alwaysVisible, selectable]);

  return (
    <XYChartAnnotationsShownIndicatorsContext.Provider value={shownIndicators}>
      {children}
    </XYChartAnnotationsShownIndicatorsContext.Provider>
  );
};
